<template>
  <dynamic-deposit-step :authenticated="false" :step="this.$options.name">
    <template v-slot:content>
      <div class="dd-headline-label ri-bold-body">הזדהות</div>
        <div class="ri-large-headline margin-bottom-s">מה הקוד שקיבלת {{ otpSentVia }}?</div>
        <default-text-input
                          :autofocus="false"
                          :label="'קוד חד-פעמי'"
                          :value="OTPInput"
                          :error-message="errorMessage"
                          input-type="tel"
                          @input="setOTP" />
    </template>
    <template v-slot:next-button>
      <dynamic-deposit-button title="הבא >" :action="verifyOTPAndContinue" :loading="loading" :disabled="!OTPInput || !!errorMessage"/>
      <div class="resend-code" v-on:click="resendAuthCode">שלחו לי קוד חדש</div>
      <whatsapp-send-again v-if="!loading && sendCodeViaSMS" @click="() => resendAuthCode(true)" />
    </template>
  </dynamic-deposit-step>
</template>

<script>

import Segment from '@/Segment';
import BaseUI from '@riseupil/base-ui';
import DDLogs from '@/DDLogs';
import * as SavingsApi from '@/api/SavingsApi';
import LoginApi from '@/api/LoginApi';
import { mapGetters } from 'vuex';
import OtpMixin from '@/mixins/OtpMixin.vue';
import WhatsappSendAgain from '@/base-components/WhatsappSendAgain.vue';
import DynamicDepositStep from './DynamicDepositStep';
import DynamicDepositButton from './DynamicDepositButton';

export default {
  name: 'DDEnterOTP',
  mixins: [OtpMixin],
  components: {
    DynamicDepositButton,
    DefaultTextInput: BaseUI.DefaultTextInput,
    DynamicDepositStep,
    WhatsappSendAgain,
  },
  props: {
    nextStep: {
      type: Function,
      required: true,
    },
    showErrorPage: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      OTPInput: '',
      errorMessage: '',
    };
  },
  async created() {
    Segment.trackUserInteraction('DynamicDeposit_EnterOTP_Entered');
  },
  computed: {
    ...mapGetters('dynamicSavings', ['idNumber']),
    ...mapGetters('session', ['activeMemberPhoneNumber']),
  },
  methods: {
    setOTP(otp) {
      this.errorMessage = '';
      this.OTPInput = otp;
    },
    resendAuthCode(useWhatsapp) {
      this.setOTP('');
      const sendPlatform = useWhatsapp === true ? 'whatsapp' : this.sendPlatform;
      Segment.trackUserInteraction('DynamicDeposit_EnterOTP_ResendClicked', { sendPlatform });
      LoginApi.generateCode({
        phoneNumber: this.activeMemberPhoneNumber.replaceAll('-', ''),
        force: true,
        sendPlatform,
      }).catch(error => {
        DDLogs.error('Failed resending otp code');
      });
    },
    async verifyOTPAndContinue() {
      Segment.trackUserInteraction('DynamicDeposit_EnterOTP_NextClicked');
      this.loading = true;
      try {
        const response = await SavingsApi.authenticate(this.idNumber, this.OTPInput);
        if (response.status === SavingsApi.STATUS.SUCCESS) {
          Segment.trackUserInteraction('DynamicDeposit_EnterOTP_ValidOTP');
          this.nextStep();
        } else if (response.data === SavingsApi.AUTHENTICATION_ERROR_TYPES.INVALID_CODE) {
          Segment.trackUserInteraction('DynamicDeposit_EnterOTP_InvalidOTP');
          this.errorMessage = 'הקוד שהזנת לא תקין';
        } else if (response.data === SavingsApi.AUTHENTICATION_ERROR_TYPES.CODE_EXPIRED) {
          Segment.trackUserInteraction('DynamicDeposit_EnterOTP_ExpiredOTP');
          this.errorMessage = 'הקוד פג תוקף';
        } else {
          this.showErrorPage();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.resend-code{
  margin-top: 40px;
  text-decoration: underline;
}
</style>
